import { call, cancelled, put, select } from 'redux-saga/effects';

import * as AppActions from '../../../actions';
import * as AppConstants from '../../../constants';
import { getInDomain } from '../../../domains/externalUtils';
import { branch, pipe } from '../../../sagas/Helpers';
import * as AppUtils from '../../../utils';

import * as PlayResumeHelpers from './helpers';

function hydrateAction(state, { payload }) {
  payload.isInitialLoad = !getInDomain('playback.utils.hasPlaybackStartedInSession', false)(state);

  if (!payload.playSourceUsingPandoraId) {
    payload.pandoraId =
      payload.pandoraId || AppUtils.Music.isOnDemandIdLike(payload.id)
        ? payload.id
        : getInDomain('playback.utils.getStationPandoraId')(state, payload.id);
  }

  payload.pandoraType =
    payload.pandoraType || AppUtils.SourceType.getPandoraTypeFromPandoraId(payload.pandoraId);
}

function* shouldInterceptPlayback({ payload: { pandoraId, pandoraType, pageUrl } }) {
  const isMobileWeb = yield select(AppUtils.Capabilities.isMobileWeb);

  if (isMobileWeb) {
    window.location = yield select(AppUtils.Route.getMobileLongLink, {
      pageUrl,
      feature: AppConstants.Urls.deepLinkParams.BACKSTAGE_PAGE,
    });
    return true;
  }

  const annotations = yield select(AppUtils.Entity.getAnnotationsById, pandoraId);

  if (
    pandoraType === AppConstants.SourceTypes.PandoraTypes.PODCAST &&
    AppUtils.Rights.isRetired(annotations)
  ) {
    yield put(
      AppActions.Modal.openModalCoachmark(AppConstants.Collection.messages.podcastUnavailable),
    );
    return true;
  }

  return false;
}

export function* playResumeSource(action) {
  yield select(hydrateAction, action);

  if (yield call(shouldInterceptPlayback, action)) {
    return;
  }

  try {
    yield call(
      pipe([
        branch(
          PlayResumeHelpers.isResuming,
          branch(
            PlayResumeHelpers.shouldSetInteractiveRadioModeOnPlay,
            PlayResumeHelpers.resumeWithNewMode,
            PlayResumeHelpers.resumePlayback,
          ),
          branch(
            PlayResumeHelpers.shouldUseAPS,
            pipe([
              PlayResumeHelpers.startingSource,
              PlayResumeHelpers.verifySourceRights,
              PlayResumeHelpers.logTTM,
              PlayResumeHelpers.startSource,
              PlayResumeHelpers.setShuffleMode,
              PlayResumeHelpers.sourceStarted,
            ]),
            PlayResumeHelpers.startStation, // legacy station playback
          ),
        ),
        PlayResumeHelpers.reRoute,
      ]),
      action,
    );
  } finally {
    if (yield cancelled()) {
      yield put(
        AppActions.Integrations.startSourceIncomplete({
          sourceId: action.payload.id,
        }),
      );
    }
  }
}
